import { ShieldCheck, CurrencyCircleDollar, UsersThree, Bank, ArrowCounterClockwise, Info, Cpu, Prohibit, Lightning, CheckSquare, Square } from "@phosphor-icons/react";
import { useI18n } from "@/i18n";

const CHIPS = [
  { key: "amounts", icon: CurrencyCircleDollar, label: "priv.mask.amounts" },
  { key: "parties", icon: UsersThree, label: "priv.mask.parties" },
  { key: "accounts", icon: Bank, label: "priv.mask.accounts" },
];

export function PrivacyToolbar({ onMask, onMaskAll, onReset, canReset, autoMask, onToggleAuto, redactCount = 0 }) {
  const { t } = useI18n();
  return (
    <div className="rounded-sm border border-lc-ocean/20 bg-lc-ocean/[0.04] p-3" data-testid="privacy-toolbar">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-1.5">
          <ShieldCheck size={15} weight="duotone" className="text-lc-ocean" />
          <span className="font-mono text-[10px] uppercase tracking-widest text-lc-ocean">{t("priv.title")}</span>
        </div>
        {redactCount > 0 && (
          <span data-testid="redacted-count-badge"
            className="inline-flex items-center gap-1 rounded-full bg-lc-ok/12 px-2.5 py-1 text-[11px] font-semibold text-lc-ok">
            <ShieldCheck size={12} weight="fill" /> {t("priv.redactedCount").replace("{n}", redactCount)}
          </span>
        )}
      </div>
      <div className="mt-2.5 flex flex-wrap items-center gap-2">
        <button data-testid="mask-all-chip" onClick={onMaskAll}
          className="inline-flex items-center gap-1.5 rounded-full bg-lc-navy px-3 py-1.5 text-xs font-bold text-white hover:bg-lc-ocean transition-colors duration-200">
          <Lightning size={13} weight="fill" /> {t("priv.mask.all")}
        </button>
        {CHIPS.map((c) => (
          <button key={c.key} data-testid={`mask-${c.key}-chip`} onClick={() => onMask(c.key)}
            className="inline-flex items-center gap-1.5 rounded-full border border-lc-ink/15 bg-white px-3 py-1.5 text-xs font-semibold text-lc-ink hover:border-lc-ocean/40 hover:bg-lc-paper transition-colors duration-200">
            <c.icon size={13} weight="duotone" className="text-lc-ocean" /> {t(c.label)}
          </button>
        ))}
        <button data-testid="mask-reset-btn" onClick={onReset} disabled={!canReset}
          className="inline-flex items-center gap-1.5 rounded-full border border-lc-ink/15 px-3 py-1.5 text-xs font-semibold text-lc-steel hover:text-lc-ink hover:bg-lc-paper transition-colors duration-200 disabled:opacity-40">
          <ArrowCounterClockwise size={13} weight="bold" /> {t("priv.reset")}
        </button>
      </div>
      <button data-testid="auto-mask-toggle" onClick={() => onToggleAuto?.(!autoMask)}
        className="mt-2.5 inline-flex items-center gap-1.5 text-[11px] font-semibold text-lc-steel hover:text-lc-ink transition-colors duration-200">
        {autoMask ? <CheckSquare size={15} weight="fill" className="text-lc-ocean" /> : <Square size={15} className="text-lc-steel" />}
        {t("priv.autoMask")}
      </button>
      <p className="mt-2 flex items-start gap-1.5 text-[11px] leading-relaxed text-lc-steel" data-testid="privacy-tip">
        <Info size={13} weight="fill" className="mt-0.5 shrink-0 text-lc-ocean" /> {t("priv.tip")}
      </p>
    </div>
  );
}

export const PRIVACY_BADGES = [
  { icon: ShieldCheck, t: "shield.b1t", d: "shield.b1d" },
  { icon: Cpu, t: "shield.b2t", d: "shield.b2d" },
  { icon: Prohibit, t: "shield.b3t", d: "shield.b3d" },
];

export function PrivacyShield() {
  const { t } = useI18n();
  return (
    <div className="rounded-sm border border-lc-ink/10 bg-white p-4" data-testid="privacy-shield-card">
      <div className="flex items-center gap-2">
        <ShieldCheck size={17} weight="duotone" className="text-lc-ok" />
        <h3 className="font-serif text-base text-lc-ink">{t("shield.wsTitle")}</h3>
      </div>
      <div className="mt-3 space-y-2.5">
        {PRIVACY_BADGES.map((b, i) => (
          <div key={i} className="flex items-start gap-2.5" data-testid={`shield-badge-${i}`}>
            <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-sm bg-lc-ok/10">
              <b.icon size={13} weight="duotone" className="text-lc-ok" />
            </div>
            <div>
              <p className="text-xs font-semibold text-lc-ink">{t(b.t)}</p>
              <p className="text-[11px] leading-relaxed text-lc-steel">{t(b.d)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
